// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2L2 2L22 2V22ZM20 4L17.5 4V6.5H20V4ZM20 8.5H17.5V11H20V8.5ZM20 13H17.5V15.5H20V13ZM17.5 17.5V20H20V17.5H17.5ZM6.5 4H4V6.5H6.5L6.5 4ZM6.5 8.5H4V11L6.5 11V8.5ZM6.5 13L4 13L4 15.5L6.5 15.5V13ZM6.5 17.5L4 17.5L4 20H6.5V17.5Z"}}]};

const TheatersFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'theaters-filled',
    ref,
    icon: element,
  },
));

TheatersFilledIcon.displayName = 'TheatersFilledIcon';

export default TheatersFilledIcon;
